import { render, staticRenderFns } from "./shortHeaderLayout.vue?vue&type=template&id=8cd4337c&scoped=true&"
import script from "./shortHeaderLayout.vue?vue&type=script&lang=ts&"
export * from "./shortHeaderLayout.vue?vue&type=script&lang=ts&"
import style0 from "./shortHeaderLayout.vue?vue&type=style&index=0&id=8cd4337c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd4337c",
  null
  
)

export default component.exports